import { Component , HostBinding } from '@angular/core';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { LogoComponent } from '../logo/logo.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    host: { 'class': 'mt-auto iefixfoo fooipadbot' },
    styleUrls: ['./footer.component.css'],
    standalone: true,
    imports: [TrackingDirective, LogoComponent]
})
export class FooterComponent {

  @HostBinding('style.width') public readonly WIDTH = '100%';
  
  title = 'webapp';
  currentYear = new Date().getFullYear();
}
